@if (isMobile) {
    <input
        #cameraInput
        type="file"
        accept="image/*"
        capture="environment"
        hidden
        (change)="onFileSelected($event)" />
}

<input
    #fileInput
    type="file"
    accept="image/*"
    hidden
    (change)="onFileSelected($event)" />

<div class="capture-actions">
    @if (isMobile) {
        <pf-button
            buttonType="submit"
            block
            [disabled]="disabled()"
            (click)="onCapturePhoto()">
            {{ captureLabel() }}
        </pf-button>
    }
    <pf-button
        [buttonType]="isMobile ? 'action' : 'submit'"
        block
        [disabled]="disabled()"
        (click)="onSelectPhoto()">
        {{ uploadLabel() }}
    </pf-button>
</div>

@if (showSoftPrompt()) {
    <div class="permission-prompt">
        <div class="permission-prompt-content">
            <pf-text type="subtitle">Camera Access Required</pf-text>
            <pf-text type="description">
                Your device may ask for camera permission. Please select
                <strong>"Allow"</strong> when prompted. This is required for
                capturing photos and is critical to completing your tasks.
            </pf-text>
            <div class="permission-prompt-actions">
                <pf-button
                    buttonType="submit"
                    block
                    (click)="onSoftPromptConfirm()"
                    >Continue</pf-button
                >
                <pf-button
                    buttonType="action"
                    block
                    (click)="onSoftPromptDismiss()"
                    >Cancel</pf-button
                >
            </div>
        </div>
    </div>
}
